import React from 'react';
import './MenuDesktop.css';
import { MenuLink } from '../Menu.interface';
import { NavLink } from 'react-router-dom';

const menuDesktop = (props: { links: MenuLink[] }) => {
  const renderLinks = props.links.map(link => {
    return (
      <li key={link.name} className="menu-link">
        <NavLink to={link.link} key={link.name}>
          {link.name}
        </NavLink>
      </li>
    )
  })
  return (
    <nav className="main-menu">
      <ul className="menu">
        {renderLinks}
      </ul>
    </nav>
  );
}

export default menuDesktop;